module.exports = __webpack_public_path__ + "static/1-3d626e705b9a53eba19b5c5b8a07e3f2.jpeg";